import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './video-player.styles';

const VideoPlayer = ({ sourceUrl, sourceType }) => {

    return (
        <Container>
            {sourceType == "youtube" ?
                <div className="App">
                    <iframe width="70%" className='iframe' src={"https://www.youtube.com/embed/" + sourceUrl} allowfullscreen></iframe>
                </div>

                : sourceType == "internal" ?
                    <div className="App">
                        <video width="70%" controls="controls">
                            <source src={sourceUrl} type="video/mp4" />
                            Your browser does not support HTML video.
                        </video>
                    </div>
                    : sourceType == "external" ?
                        <div className="App">
                            <video width="70%" controls="controls">
                                <source src={sourceUrl} type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </div>

                        : null
            }
        </Container>
    );
};

VideoPlayer.propTypes = {
    sourceUrl: PropTypes.string,
    sourceType: PropTypes.string
};

export default VideoPlayer;
